module.exports = __webpack_public_path__ + "media/images/yoshimoto-bb77f8e4e9fd7a392566dd673d0a211a.png";